import _typeof from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
import MonacoEditor from '@/views/visual/dataScreen/js/utils/monaco-editor';
export default {
  components: {
    MonacoEditor: MonacoEditor
  },
  data: function data() {
    return {
      code: '',
      options: {
        fontSize: 12
      }
    };
  },
  props: {
    language: {
      type: String,
      default: 'javascript'
    },
    disabled: Boolean,
    height: {
      type: [String, Number],
      default: 400
    },
    value: [String, Object, Array]
  },
  watch: {
    code: function code(val) {
      this.$emit('input', val);
    },
    value: {
      handler: function handler(val) {
        if (_typeof(val) == 'object') {
          this.code = JSON.stringify(val, null, 4);
        } else {
          this.code = val || '';
        }
      },
      immediate: true,
      deep: true
    }
  }
};